import { ErrorModel, IErrorModel } from 'models/errorModel';
import { useState } from 'react';

/**
 * Simplifies form modal logic
 * @param submit Promise to invoke as submit
 * @param onClose Function called when the modal is closed
 * @param clear Fuunction called as an optional step to clear other states
 * @returns Array: [handleSubmit function, handleClose function, error state]
 */
const useModalLogic = <TModel>(
  submit: () => Promise<void | undefined>,
  onClose: () => void,
  clear?: () => void,
): [() => Promise<boolean>, () => void, IErrorModel<TModel> | undefined] => {
  const [error, setError] = useState<IErrorModel<TModel>>();

  const handleSubmit = async () => {
    try {
      await submit();
      return true;
    } catch (caughtError) {
      if (ErrorModel.isErrorModel<TModel>(caughtError)) {
        setError(caughtError.content);
      }
      console.error(caughtError);
      return false;
    }
  };
  const handleClose = () => {
    setError(undefined);
    if (clear) clear();
    onClose();
  };

  return [handleSubmit, handleClose, error];
};
export default useModalLogic;
